import styled from "styled-components"
import { Input } from 'linkdrop-ui'

export const InputStyled = styled(Input)``

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TokenSymbol = styled.span`
  font-size: 14px;
  color: #666;
  min-width: 50px;
`
